module.exports = __webpack_public_path__ + "media/heist_dice_nice.f5779088.ogg";